import React, { Component } from "react";

import { Link } from "react-router-dom";

function NoMatch(props) {
  //----------------------------|END PREPS|----------------------------\\
  return (
    <main className="content">
      <div className="container-fluid card">
        <div className="d-table-cell align-middle" style={{ paddingTop: "20vh", paddingBottom: "20vh" }}>
          <div className="text-center">
            <h1 className="display-1 fw-bold">404</h1>
            <p className="h1">Page not found.</p>
            <p className="h2 fw-normal mt-3 mb-4">The page you are looking for might have been removed.</p>
            <Link to="/clients" className="btn btn-primary btn-lg">
              Return to Clients
            </Link>
          </div>
        </div>
      </div>
    </main>
  );
}

export default NoMatch;
